module.exports = __webpack_public_path__ + "static/element-with-padding-3b89ea5bdb105e64e111e870fda4e06d.mp4";